/**
 * Trang + bộ lọc của màn Chuyển khoản trả hộ, giữ trên URL search param.
 *
 * Config để ở đây (thay vì khai inline trong file route như các màn khác) để
 * giữ được bộ test đơn vị vốn đã có cho phần parse URL.
 */
import { defineListFilters } from '@/components/common/filters/core'
import { dateFilter } from '@/components/common/filters/date-filter'
import { growerFilter } from '@/components/common/filters/grower-filter'
import { m } from '@/lib/paraglide/messages'

export type GrowerPaymentsSearch = {
    grower_id?: string
    from_date?: string
    to_date?: string
    page?: number
}

/**
 * Bộ lọc khai một lần, suy ra: parser URL, mặc định, badge đếm, chip.
 *
 * URL là nguồn sự thật nên giá trị không đáng tin: người dùng sửa tay được,
 * link cũ mang giá trị đã bỏ. `dateFilter` chỉ nhận đúng `yyyy-mm-dd`, sai
 * dạng thì loại bỏ thay vì đẩy xuống API.
 */
export const GROWER_PAYMENTS_FILTERS = defineListFilters({
    grower_id: growerFilter({ label: m.grower_payment_filter_grower }),
    from_date: dateFilter({ label: m.grower_payment_filter_from }),
    to_date: dateFilter({ label: m.grower_payment_filter_to }),
})
